import { useEffect, useState } from "react"
import { useActsStore } from "../store/useActsStore"
import { useInterestPointStore } from "../store/uneInterestPointsStore"

import HtmlByPoint from "./HtmlByPoint"
import TextByPoint from "./TextByPoint"

export default function UiPass() {
  const getCurrentActId = useActsStore((s) => s.getCurrentActId)
  const id = getCurrentActId()

  const activeInterestPointId = useInterestPointStore((s) => s.activeInterestPointId)

  const isActe4 = id === 3

  const show = isActe4 && activeInterestPointId != null

  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    if (show) {
      setMounted(true)
      return
    }
    const t = setTimeout(() => setMounted(false), 400)
    return () => clearTimeout(t)
  }, [show])

  if (!mounted) return null

  return (
    <div className="acte-four-container">
      <TextByPoint activeInterestPointId={activeInterestPointId} />
      <HtmlByPoint activeInterestPointId={activeInterestPointId} />
    </div>
  )
}
